import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface LocationState {
  latitude: number | null
  longitude: number | null
  error: string | null
  isLoading: boolean
  permissionState: 'prompt' | 'granted' | 'denied' | 'unsupported' | null
  setLocation: (latitude: number, longitude: number) => void
  setError: (error: string | null) => void
  setIsLoading: (isLoading: boolean) => void
  setPermissionState: (state: 'prompt' | 'granted' | 'denied' | 'unsupported') => void
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      latitude: null,
      longitude: null,
      error: null,
      isLoading: false,
      permissionState: null,
      setLocation: (latitude, longitude) => set({ latitude, longitude, error: null }),
      setError: (error) => set({ error }),
      setIsLoading: (isLoading) => set({ isLoading }),
      setPermissionState: (permissionState) => set(
        permissionState === 'denied'
          ? { permissionState, latitude: null, longitude: null }
          : { permissionState }
      ),
    }),
    {
      name: 'location-store',
      partialize: (state) => ({
        latitude: state.latitude,
        longitude: state.longitude,
        permissionState: state.permissionState,
      }),
    }
  )
)
